<template>
	<div class="page-title page-title-bg margin-bottom-30">
		<div class="container">
			<div class="row">
				<div class="col-xs-12 text-center">
					<span class="section-title-line"></span>
					<h2>{{ title }}</h2>
					<p v-if="hasBreadcrumb">
						<a id="focus" href="/"><i class="fa fa-home" aria-hidden="true"></i></a>&nbsp; > &nbsp;
						<span v-for="(breadcrumb, index) in breadcrumbs" :key="index">
							<span v-if="isLast(index)">{{
								$t('Page.Breadcrumb.' + (breadcrumb.name === '.' ? name : breadcrumb.name))
							}}</span>
							<router-link
								v-if="!isLast(index)"
								:to="{
									name: breadcrumb.link === '.' ? '#' : breadcrumb.link,
									params: breadcrumb.params ? breadcrumb.params : breadcrumb.link,
								}"
								>{{ $t('Page.Breadcrumb.' + (breadcrumb.name === '.' ? name : breadcrumb.name)) }}</router-link
							>
							<span v-if="!isLast(index)">&nbsp; > &nbsp;</span>
						</span>
					</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'PageTitle',
	props: {
		breadcrumbs: {
			type: Array,
			required: true,
		},
		name: {
			type: String,
			required: true,
		},
		title: {
			type: String,
			required: true,
		},
	},
	computed: {
		hasBreadcrumb() {
			return this.breadcrumbs.length > 0
		},
	},
	methods: {
		isLast(index) {
			return index === this.breadcrumbs.length - 1
		},
	},
}
</script>



// WEBPACK FOOTER //
// src/components/partials/PageTitle.vue